<template>
  <div>
    <v-card flat>
          <!--            <v-card-text >-->
          <div class="bg-img-avatar">
            <img :src="user_image"/>
          </div>
          <div class="profile-card">
            <div class="profile-img">
              <img :src="user_image"/>
            </div>
            <div class="profile-name-num">
              <div class="row">
                <div class="col-6 text-right black-text" v-on:click="goToSetting()">
                  {{user_name}}
                  <v-icon>mdi-pencil</v-icon>
                </div>
                <div class="col-6" style="text-align: start">
                  <span class="num black-text">
                     {{user_mobile}}
                  </span>
                </div>
              </div>
            </div>
            <div class="profile-action">
              <div class="chat-list">
                <div class="chat-prev" v-on:click="goToDetail(item)">

                  <div class="row">
                    <div class="col-2">
                      <img style="border-radius: 0;width: 30px;height: 30px;" src="/img/account_name.svg"/>
                    </div>
                    <div class="col-10">
                      <span class="name">
                  {{ $t('accountName') }}
                    </span>
                      <span  class="text">
              {{user_name}}
                      </span>
                    </div>
                  </div>

                </div>

              </div>
              <div class="chat-list">
                <div class="chat-prev" v-on:click="goToDetail(item)">

                  <div class="row">
                    <div class="col-2">
                      <img style="border-radius: 0;width: 30px;height: 30px;" src="/img/account_mobile.svg"/>
                    </div>
                    <div class="col-10">
                      <span class="name">
                  {{ $t('mobile') }}
                    </span>
                      <span  class="text">
              {{user_mobile}}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="chat-list">
                <div class="chat-prev" v-on:click="goToSavedMessage()">

                  <div class="row">
                    <div class="col-2">
                      <img style="border-radius: 0;width: 30px;height: 30px;" src="/img/saved_message.svg"/>
                    </div>
                    <div class="col-10">
                      <span class="name">
                  {{ $t('savedMessages') }}
                    </span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="chat-list">
                <div class="chat-prev" v-on:click="$router.push({path: '/contact-us', params: {}})">

                  <div class="row">
                    <div class="col-2">
                      <img style="border-radius: 0;width: 30px;height: 30px;" src="/img/contact_us.svg"/>
                    </div>
                    <div class="col-10">
                      <span class="name">
                  {{ $t('contactUs') }}
                    </span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="chat-list">
                <div class="chat-prev" v-on:click="logout()">

                  <div class="row">
                    <div class="col-2">
                      <img style="border-radius: 0;width: 30px;height: 30px;" src="/img/exit_file.svg" />
                    </div>
                    <div class="col-10">
                      <span class="name">
                  {{ $t('signOut') }}
                    </span>
                    </div>
                  </div>
                </div>

              </div>
              <div >
                <div >

                  <div class="row text-center" style="place-content: center">

                    <div class="12 " >
                  {{ $t('version', {app_version: app_version}) }}
                    </div>
                  </div>
                </div>

              </div>

<!--              <div class="width-50" v-on:click="goToContacts()">-->
<!--                <v-icon>-->
<!--                  mdi-account-box-outline-->
<!--                </v-icon>-->
<!--                <span>{{ $t('contacts') }}</span>-->
<!--              </div>-->
<!--              <div class="width-50" v-on:click="goToSavedMessage()">-->
<!--                <v-icon>-->
<!--                  mdi-forum-->
<!--                </v-icon>-->
<!--                <span>{{ $t('savedMessages') }}</span>-->
<!--              </div>-->
<!--              <div class="width-50" v-on:click="logout()">-->
<!--                <v-icon>-->
<!--                  mdi-exit-to-app-->
<!--                </v-icon>-->
<!--                <span>{{ $t('exit') }}</span>-->
<!--              </div>-->
<!--              <div class="width-50" v-on:click="$router.push({path: '/contact-us', params: {}})">-->
<!--                <v-icon>-->
<!--                  mdi-phone-message-outline-->
<!--                </v-icon>-->

<!--                <span>{{ $t('contactUs') }}</span>-->
<!--              </div>-->

            </div>
          </div>
          <!--            </v-card-text>-->
        </v-card>
  </div>

</template>
<script>

  export default {
    data () {
      return {
        tab: null,
        user_name: '',
        user_mobile: '',
        user_image: '',
        app_version: '',
      }
    },
    mounted () {
      this.app_version = process.env.VUE_APP_APP_VERSION
      var user_data = JSON.parse(localStorage.getItem('profile'))

      this.user_name = user_data.UserName
      this.user_image = user_data.ThumbPath
      this.user_mobile = localStorage.getItem('phone').toString().replace('+98', '0')
    },
    methods: {
      logout () {
        localStorage.setItem('profile', '')
        localStorage.setItem('phone', '')
        localStorage.setItem('password', '')
        localStorage.setItem('party_id', '')
        this.$router.push({ name: 'login', params: {} })
      },
      change_post () {
        localStorage.setItem('party_id', '')
        this.$router.push({ name: 'post_login', params: {} })
      },
      goToSetting () {
        this.$router.push({ name: this.$t('settings'), params: {} })
      },
      goToContacts () {
        this.$router.push({ path: '/contacts', params: {} })
      },
      goToSavedMessage () {
        // this.$router.push({path: '/saved-message', params: {}})
        var user_data = JSON.parse(localStorage.getItem('profile'))
        console.log('user_dat ', user_data)
        const last_chat_detail = {
          RecType: 0,
          UserOrGroupId: user_data.UserId
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({ name: this.$t('conversation'), params: {} })
      }
    }
  }
</script>
